@use '../../assets/styles/theme';

body {
  background: linear-gradient(135deg, #ff8c42 0%, #ff7e5f 50%, #feb47b 100%);
}

.container {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: linear-gradient(135deg, #ff8c42 0%, #ff7e5f 50%, #feb47b 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    animation: rotate 30s linear infinite;
  }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.logoImage {
  height: 120px;
  width: 280px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(../../assets/images/alice-logo.png);
  background-size: contain;
  margin-bottom: 2rem;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}

.loginInfo {
  color: #64748b;
  font-size: 16px;
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.6;
  font-weight: 400;

  strong {
    color: #334155;
    font-weight: 600;
  }
}

.loginForm {
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 2.5rem;
  color: #1e293b;
  width: 480px;
  max-width: 90vw;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  animation: slideUp 0.5s ease-out;

  h1 {
    font-size: 2.5em;
    margin-bottom: 0.3em;
    padding: 12px 0;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Modern Input Group with Floating Label
.inputGroup {
  position: relative;
  width: 100%;
  margin: 1.5rem 0;
}

.inputIcon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 18px;
  transition: all 0.3s ease;
  z-index: 2;
}

.modernInput {
  width: 100%;
  padding: 18px 18px 18px 52px;
  font-size: 16px;
  color: #1e293b;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  outline: none;
  transition: all 0.3s ease;
  font-family: 'Lato', sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    background: white;
    border-color: #ff7e5f;
    box-shadow: 
      0 0 0 4px rgba(255, 126, 95, 0.15),
      0 4px 12px rgba(0, 0, 0, 0.08);
    
    ~ .inputIcon {
      color: #ff7e5f;
    }
  }
}


// OTP Boxes Styling
.otpContainer {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 2rem 0 1.5rem;
  padding: 0 10px;
}

.otpBox {
  width: 56px;
  height: 64px;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  color: #1e293b;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Lato', monospace;
  caret-color: #ff7e5f;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

  &:focus {
    background: white;
    border-color: #ff7e5f;
    box-shadow: 
      0 0 0 4px rgba(255, 126, 95, 0.15),
      0 8px 16px rgba(255, 126, 95, 0.15);
    transform: scale(1.05);
  }

  &:not(:placeholder-shown) {
    background: white;
    border-color: #10b981;
    color: #059669;
  }

  // Pulsing animation for empty boxes when focused on any
  &:focus ~ &:empty {
    animation: pulse 2s ease-in-out infinite;
  }
}

@keyframes pulse {
  0%, 100% {
    border-color: #e2e8f0;
  }
  50% {
    border-color: #cbd5e1;
  }
}

// Legacy form field support
.formField {
  position: relative;
  font-size: 20px;
  border-bottom: 1px solid #e74c3c;
  margin: 20px 0 8px 0;
  transition: 0.3s;
  width: 90%;

  input {
    border: none;
    outline: none;
    background: transparent;
    color: black;
    padding-left: 10px;
  }
}

.resetInput {
  width: 65%;
}
.signupInput {
  width: 65%;
  margin-bottom: 12px;
}

.leftColumn {
  height: 100%;
  background-image: url(../../assets/images/socks.jpg);
  background-position: 80%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex: 2;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 140, 66, 0.3) 0%, rgba(255, 126, 95, 0.3) 50%, rgba(254, 180, 123, 0.3) 100%);
  }
}

// Responsive adjustments
@media (max-width: 900px) {
  .loginForm {
    width: 420px;
    padding: 2.5rem 2rem;
  }

  .otpBox {
    width: 48px;
    height: 56px;
    font-size: 24px;
  }

  .otpContainer {
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .loginForm {
    width: 100%;
    margin: 1rem;
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }

  .logoImage {
    height: 90px;
    width: 220px;
  }

  .otpBox {
    width: 42px;
    height: 50px;
    font-size: 22px;
  }

  .otpContainer {
    gap: 6px;
  }
}

// Signup Modal - Custom Animations & Effects
.signupHeaderAnimated {
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 100%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 60%);
    animation: rotate 20s linear infinite;
  }
}

.signupHeaderGradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ff8c42, #ff7e5f, #feb47b, #ff7e5f, #ff8c42);
  background-size: 200% 100%;
  animation: gradientShift 3s ease infinite;
}

.signupHeaderGlow {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top right, rgba(254, 180, 123, 0.2), transparent 50%);
  pointer-events: none;
}

@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.slideDown {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
